/**
 * Resource that represents an optional configuration key-value pair stored in the database.
 *
 * @name Session
 * @class
 * @augments TmrResource
 */
export const factory = [
  'Session',
  /*@ngInject*/ (TmrApi, TmrResource, Place, Zone, Checklist) => {
    let actions = {
      close: {
        url: TmrApi.endpoint('Session.close'),
        method: 'POST',
        isArray: false,
      },
      filteredSearch: {
        url: TmrApi.endpoint('Session.filteredSearch'),
        method: 'GET',
        isArray: true,
      },
      itemStatus: {
        url: TmrApi.endpoint('Session.itemStatus'),
        method: 'GET',
        isArray: false,
      },
    }

    let referencedProperties = [
      { property: 'place', resource: Place },
      { property: 'destinationZone', resource: Zone },
      { property: 'checklist', resource: Checklist },
    ]

    let defaultValues = () => ({
      attributes: {},
    })

    let Session = TmrResource(
      'Session',
      actions,
      referencedProperties,
      defaultValues
    )

    /**
     * Loads a single configuration value.
     *
     * @method Session#getValue
     */
    function getValue(code) {
      if (typeof code !== 'string') {
        throw new Error(
          'Session.getValue(code) action requires a configuration key (code)'
        )
      }
      return TmrApi.get('Session', { id: null }, { params: { code } }).then(
        res => (res.data.length ? res.data[0].value : null)
      )
    }

    Object.assign(Session, { getValue })

    return Session
  },
]
